var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloorSegments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b692d2d5-49a6-4444-b5a0-5c8573e4ecae",
    "data-name": "b431b8c3-455b-48ed-845e-b14d9d69b5fe",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "b431aa4b-90f5-4825-a71a-8e8c31f1e80f",
    "data-name": "aa8d5d12-6c31-4c05-b183-78c46f70da95",
    x: 20,
    y: 9.44,
    width: 17.25,
    height: 22.65,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "fba6bb77-863d-4d86-901c-53b5a92039af",
    "data-name": "aa8d5d12-6c31-4c05-b183-78c46f70da95",
    x: 2.75,
    y: 7.45,
    width: 17.25,
    height: 11.49,
    fill: "#b3b3b3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "be8f01e5-b254-4e2a-9e5f-4d357b7d8ad3",
    "data-name": "aa8d5d12-6c31-4c05-b183-78c46f70da95",
    x: 2.75,
    y: 18.94,
    width: 17.25,
    height: 13.15,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 7.45,
    width: 1.99,
    height: 24.64
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.26,
    y: 7.45,
    width: 1.99,
    height: 24.64
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 7.45,
    width: 34.5,
    height: 1.99
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.68,
    y: 30.1,
    width: 22.57,
    height: 1.99
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 30.1,
    width: 6.12,
    height: 1.99
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.05,
    y1: 31.09,
    x2: 11.74,
    y2: 25.02,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 9.44,
    x2: 20,
    y2: 21.44,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10.86,
    y1: 18.94,
    x2: 7.95,
    y2: 18.94,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 15.47,
    y1: 18.94,
    x2: 12.57,
    y2: 18.94,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 18.94,
    x2: 17.09,
    y2: 18.94,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 25.77,
    x2: 20,
    y2: 31.09,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 6.36,
    y1: 18.94,
    x2: 4.74,
    y2: 18.94,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorSegments);
export default __webpack_public_path__ + "static/media/FloorSegments.a1c6bc9e2d981a4c01029acc45a485e2.svg";
export { ForwardRef as ReactComponent };